import { VariaveisAmbiente } from 'config';
import { PagamentoModel } from 'model/api/gestao/pagamento/pagamento-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePostAdicionarPagamento() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postAdicionarPagamento = useCallback(
        (pagamento: PagamentoModel) =>
            invocarApi({
                url: `/${VariaveisAmbiente.apiVersion}/FormaPagamento`,
                method: 'POST',
                data: pagamento,
                enviarTokenUsuario: true,
                timeout: 100000
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postAdicionarPagamento,
    };
}
